import React from 'react'
import { Container } from 'reactstrap'

import cloudnexaLogo from '../../../../images/logo-white.png'
import awsLogo from '../../../../images/aws-logo-white-smile.svg'
import { Link } from 'gatsby'
import { MANAGED_CLOUD_SUPPORT_ROUTE, CAM_ROUTE } from '../../../../routes'

const RcSection = ({ children, isDisabled = false, title, to }) => {
  return (
    <div
      className={`ResponsibilityChart__section ${
        isDisabled ? 'rc-disabled' : ''
      }`}
    >
      {isDisabled && (
        <div className="rc_learnMore">
          <Link className="btn btn-info" to={to}>
            Learn more about {title}
          </Link>
        </div>
      )}
      {children}
    </div>
  )
}

const ResponsibilityChart = ({ disabled = [], title, lead }) => {
  return (
    <section className="ResponsibilityChart">
      <Container>
        <h2 className="ResponsibilityChart__title">
          {title ? (
            title
          ) : (
            <>
              Shared&nbsp;
              <span className="text-dark-blue">Responsibility Model</span>
            </>
          )}
        </h2>

        <div className="ResponsibilityChart__lead">
          <div>{lead}</div>
        </div>

        <div className="ResponsibilityChart__chart">
          <div className="ResponsibilityChart__section">
            <div className="ResponsibilityChart__sectionInner">
              <div className="bg-green rc_cell rc_title">customer</div>
              <div className="ResponsibilityChart__right">
                <div className="bg-green rc_cell">customer data</div>
                <div className="bg-green rc_cell">application</div>
              </div>
            </div>
          </div>

          <RcSection
            isDisabled={disabled.includes('mcs')}
            to={MANAGED_CLOUD_SUPPORT_ROUTE}
            title="Managed Cloud Support"
          >
            <div className="ResponsibilityChart__sectionInner">
              <div className="bg-blue rc_cell rc_title rc_cs_title">
                <img
                  className="rc_title__logo"
                  src={cloudnexaLogo}
                  alt="cloudnexa logo"
                />
                <div>Managed Cloud Support</div>

                <Link to={MANAGED_CLOUD_SUPPORT_ROUTE}>Learn more</Link>
              </div>
              <div className="ResponsibilityChart__right">
                <div className="bg-blue rc_cell">
                  identity & access management
                </div>
                <div className="bg-blue rc_cell">
                  network & firewall configuration
                </div>
                <div className="bg-blue rc_cell">
                  operating system, DB engines, & platforms
                </div>
                <div className="rc_row rc_row_4">
                  <div className="bg-blue rc_cell">Monitoring</div>
                  <div className="bg-blue rc_cell">Logging</div>
                  <div className="bg-blue rc_cell">Backups</div>
                  <div className="bg-blue rc_cell">System Maintenance</div>
                </div>
              </div>
            </div>
          </RcSection>

          <RcSection
            isDisabled={disabled.includes('cam')}
            to={CAM_ROUTE}
            title="Cloud Architect Manager"
          >
            <div className="ResponsibilityChart__sectionInner">
              <div className="bg-dark-blue rc_cell rc_title rc_cs_title">
                <img
                  className="rc_title__logo"
                  src={cloudnexaLogo}
                  alt="cloudnexa logo"
                />
                <div>Cloud Architect Manager</div>

                <Link to={CAM_ROUTE}>Learn more</Link>
              </div>
              <div className="ResponsibilityChart__right">
                <div className="bg-dark-blue rc_cell">
                 Architectural & Best Practice Guidance
                </div>
                <div className="bg-dark-blue rc_cell">
                  Cost Optimization Reviews
                </div>
                <div className="bg-dark-blue rc_cell">
                  Operational Standardization
                </div>
                <div className="rc_row rc_row_4">
                  <div className="bg-dark-blue rc_cell">Strategies</div>
                  <div className="bg-dark-blue rc_cell">Planning</div>
                  <div className="bg-dark-blue rc_cell">Evaluations</div>
                  <div className="bg-dark-blue rc_cell">Knowledge Share</div>
                </div>
              </div>
            </div>
          </RcSection>

          <div className="ResponsibilityChart__section">
            <div className="ResponsibilityChart__sectionInner">
              <div className="bg-orange rc_cell rc_title">
                <img className="rc_title__logo" src={awsLogo} alt="aws logo" />
              </div>
              <div className="ResponsibilityChart__right">
                <div className="bg-orange rc_cell">service availability</div>
                <div className="rc_row rc_row_4">
                  <div className="bg-orange rc_cell">hardware</div>
                  <div className="bg-orange rc_cell">network</div>
                  <div className="bg-orange rc_cell">virtualization</div>
                  <div className="bg-orange rc_cell">aws console</div>
                </div>
                <div className="bg-orange rc_cell">
                  <b>aws global infrastructure</b>
                </div>
                <div className="rc_row rc_row_3">
                  <div className="bg-orange rc_cell">regions</div>
                  <div className="bg-orange rc_cell">availability zones</div>
                  <div className="bg-orange rc_cell">edge locations</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}

export default ResponsibilityChart
